/**
 * This function randomizes the order of an array in a very performant fashion (don't use sort).
 * @param array Any array
 */
const shuffleArray = (array) => {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
        const randomIndexBeforeI = Math.floor(Math.random() * (i + 1));
        // Below just switches and assigns both at once to prevent one overwriting the other
        [result[i], result[randomIndexBeforeI]] = [result[randomIndexBeforeI], result[i]];
    }
    return result;
};
export default shuffleArray;
//# sourceMappingURL=shuffleArray.js.map